import { Component } from "@angular/core"

@Component({
    selector: 'app-news',
    templateUrl: 'news.component.html',
    styleUrls: ['news.component.css']
})
export class NewsComponent{
    header: string = "The latests news";
}